/**
 * Segment criteria options for add-segment-modal.
 * Shared operator lists (text comparison, is/is not) avoid duplicating the same options for visit_frequency and total_spend.
 */

export interface CriteriaOptionItem {
  label: string;
  value: string;
  value_type: string;
}

export interface CriteriaOption {
  label: string;
  value: string;
  options: CriteriaOptionItem[];
}

/** Operators for numeric/text criteria (visit frequency, total spend). */
export const SEGMENT_CRITERIA_OPERATORS_TEXT: CriteriaOptionItem[] = [
  { label: 'Does Not Equal (≠)', value: 'does_not_equal', value_type: 'Text' },
  { label: 'Equals (=)', value: 'equals', value_type: 'Text' },
  { label: 'Less than (<)', value: 'less_than', value_type: 'Text' },
  { label: 'Less Than or Equal To (≤)', value: 'less_than_or_equal_to', value_type: 'Text' },
  { label: 'Greater Than (>)', value: 'greater_than', value_type: 'Text' },
  { label: 'Greater Than or Equal To (≥)', value: 'greater_than_or_equal', value_type: 'Text' }
];

/** Operators for last visit date. */
export const SEGMENT_CRITERIA_OPERATORS_LAST_VISIT: CriteriaOptionItem[] = [
  { label: 'On', value: 'on', value_type: 'date' },
  { label: 'Before', value: 'before', value_type: 'date' },
  { label: 'After', value: 'after', value_type: 'date' },
  { label: 'Between', value: 'between', value_type: 'date_range' },
  { label: 'In the last', value: 'in_the_last', value_type: 'days' },
  { label: 'Not in the last', value: 'not_in_the_last', value_type: 'days' }
];

/** "Is" / "Is not" for a given value_type. */
export function segmentCriteriaOperatorsIsIsNot(valueType: string): CriteriaOptionItem[] {
  return [
    { label: 'Is', value: 'is', value_type: valueType },
    { label: 'Is not', value: 'is_not', value_type: valueType }
  ];
}

/** Full criteria options for segment modal (visit frequency, total spend, last visit date, package, vehicle make, car wash type). */
export const SEGMENT_CRITERIA_OPTIONS: CriteriaOption[] = [
  { label: 'Visit frequency', value: 'visit_frequency', options: SEGMENT_CRITERIA_OPERATORS_TEXT },
  { label: 'Total spend', value: 'total_spend', options: SEGMENT_CRITERIA_OPERATORS_TEXT },
  { label: 'Last Visit Date', value: 'last_visit_date', options: SEGMENT_CRITERIA_OPERATORS_LAST_VISIT },
  { label: 'Package Name', value: 'package_name', options: segmentCriteriaOperatorsIsIsNot('package') },
  { label: 'Vehicle make', value: 'vehicle_make', options: segmentCriteriaOperatorsIsIsNot('vehicle_make') },
  { label: 'Car wash type', value: 'car_wash_type', options: segmentCriteriaOperatorsIsIsNot('car_wash_type') }
];
